/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const JobGroup = {
    Billing: 'Billing',
    Payment: 'Payment',
    Balance: 'Balance',
    Appointment: 'Appointment',
    System: 'System'
} as const;
export type JobGroup = typeof JobGroup[keyof typeof JobGroup];


export function instanceOfJobGroup(value: any): boolean {
    for (const key in JobGroup) {
        if (Object.prototype.hasOwnProperty.call(JobGroup, key)) {
            if (JobGroup[key as keyof typeof JobGroup] === value) {
                return true;
            }
        }
    }
    return false;
}

export function JobGroupFromJSON(json: any): JobGroup {
    return JobGroupFromJSONTyped(json, false);
}

export function JobGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobGroup {
    return json as JobGroup;
}

export function JobGroupToJSON(value?: JobGroup | null): any {
    return value as any;
}

export function JobGroupToJSONTyped(value: any, ignoreDiscriminator: boolean): JobGroup {
    return value as JobGroup;
}

